import React, { useEffect, useState } from "react";
import styles from "./non-academic-activity.module.css";
import AddNonAcademicContent from "./components/add-non-academic-content/add-non-academic-content";
import { Spin } from "antd";
import { toast } from "react-toastify";
import CustomDrawer from "../../../../../common/custom-drawer/custom-drawer";
import NonAcademicInstitutionCard from "../../../../../components/non-academic-stat-institution/non-academic-stat-institution";
import AddButtonExpanded from "../../../../../components/add-button-expanded/add-button-expanded";
import {
  createInstitutionActivity,
  deleteInstitutionActivity,
  fetchNonAcademicStats,
  updateInstitutionActivity,
} from "../../../../../services/subject";

const TYPE = {
  HOUSE: "House",
  CLUB: "Club",
  SPORT: "Sport",
};

const NonAcademicActivity = ({ institutionId }) => {
  const [stats, setStats] = useState({
    [TYPE.HOUSE]: [],
    [TYPE.CLUB]: [],
    [TYPE.SPORT]: [],
  });
  const [showModal, setShowModal] = useState({ status: false, modalFor: "" });
  const [contentInfo, setContentInfo] = useState(null);
  const [sectionLoader, setSectionLoader] = useState({
    [TYPE.HOUSE]: false,
    [TYPE.CLUB]: false,
    [TYPE.CLUB]: false,
  });

  const onClose = () => {
    setShowModal({ status: false, modalFor: "" });
    setContentInfo(null);
  };

  const fetchInfo = async () => {
    try {
      setSectionLoader({
        [TYPE.HOUSE]: true,
        [TYPE.CLUB]: true,
        [TYPE.SPORT]: true,
      });
      const [houseResp, clubRep, sportResp] = await Promise.all([
        fetchNonAcademicStats(TYPE.HOUSE?.toUpperCase()),
        fetchNonAcademicStats(TYPE.CLUB.toUpperCase()),
        fetchNonAcademicStats(TYPE.SPORT.toUpperCase()),
      ]);
      setStats({
        [TYPE.HOUSE]: houseResp?.data?.data?.overview?.length
          ? houseResp.data.data.overview[0].data
          : [],
        [TYPE.CLUB]: clubRep?.data?.data?.overview?.length
          ? clubRep.data.data.overview[0].data
          : [],
        [TYPE.SPORT]: sportResp?.data?.data?.overview?.length
          ? sportResp.data.data.overview[0].data
          : [],
      });
    } catch (err) {
      toast.error("Failed to Fetch Items");
    } finally {
      setSectionLoader({
        [TYPE.HOUSE]: false,
        [TYPE.CLUB]: false,
        [TYPE.SPORT]: false,
      });
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  const handleEditItem = (item, type) => {
    setContentInfo(item);
    setShowModal({ status: true, modalFor: type });
  };

  const handleDeleteItem = async (item, type) => {
    try {
      setShowModal({ status: false, modalFor: "" });
      setSectionLoader((pre) => ({ ...pre, [type]: true }));
      await deleteInstitutionActivity(item.activity_id);
      const resp = await fetchNonAcademicStats(type?.toUpperCase());
      setStats((pre) => ({
        ...pre,
        [type]: resp?.data?.data?.overview?.length
          ? resp.data.data.overview[0].data
          : [],
      }));
      toast.success(`${type} Deleted Successfully!`);
    } catch (err) {
      toast.error("Failed to Delete!");
    } finally {
      setSectionLoader((pre) => ({ ...pre, [type]: false }));
    }
  };

  const handleSubmit = async (name, teacherId) => {
    try {
      if (!name?.length) return;
      setSectionLoader((pre) => ({ ...pre, [showModal.modalFor]: true }));

      const data = {
        name: name,
        teacher_id: teacherId,
        type: showModal.modalFor.toUpperCase(),
      };

      if (contentInfo)
        await updateInstitutionActivity(contentInfo?.activity_id, data);
      else {
        data.institution_id = institutionId;
        data.type = showModal.modalFor?.toUpperCase();
        await createInstitutionActivity(data);
      }
      onClose();
      const resp = await fetchNonAcademicStats(
        showModal.modalFor.toUpperCase()
      );
      setStats((pre) => ({
        ...pre,
        [showModal.modalFor]: resp?.data?.data?.overview[0]?.data,
      }));
      toast.success(
        `${showModal.modalFor} is ${
          contentInfo ? "Edited" : "Added"
        } Successfully!`
      );
    } catch (err) {
      console.log(err);
      toast.error("Failed to Add/Edit Item");
    } finally {
      setSectionLoader((pre) => ({ ...pre, [showModal.modalFor]: false }));
    }
  };

  return (
    <>
      <div className={styles.container}>
        <h3>House</h3>
        <Spin spinning={sectionLoader[TYPE.HOUSE]}>
          <div className={styles.main_layout}>
            {stats?.[TYPE.HOUSE]?.map((item, idx) => {
              return (
                <div key={idx}>
                  <NonAcademicInstitutionCard
                    total_students={item?.total_students ?? 0}
                    handleEdit={handleEditItem.bind(null, item, TYPE.HOUSE)}
                    NonAcademicInstitutionCard
                    handleDelete={handleDeleteItem.bind(null, item, TYPE.HOUSE)}
                    total_male={item?.male_count ?? 0}
                    total_female={item?.female_count ?? 0}
                    total_medals={item?.total_medals ?? 0}
                    level={item?.activity_name ?? "-"}
                    teacher_name={item?.teacher_name ?? "N/A"}
                    chart_label_1="Male"
                    chart_label_2="Female"
                    chart_color_1="rgba(23, 160, 34, 1)"
                    chart_color_2="rgba(172, 216, 30, 1)"
                  />
                </div>
              );
            })}
            <AddButtonExpanded
              onClick={() =>
                setShowModal({ status: true, modalFor: TYPE.HOUSE })
              }
              buttonLabel="Add House"
            />
          </div>
        </Spin>
        <h3>Clubs</h3>
        <Spin spinning={sectionLoader[TYPE.CLUB]}>
          <div className={styles.main_layout}>
            {stats?.[TYPE.CLUB]?.map((item, idx) => {
              return (
                <div key={idx}>
                  <NonAcademicInstitutionCard
                    total_students={item?.total_students ?? 0}
                    handleEdit={handleEditItem.bind(null, item, TYPE.CLUB)}
                    handleDelete={handleDeleteItem.bind(null, item, TYPE.CLUB)}
                    total_male={item?.male_count ?? 0}
                    total_female={item?.female_count ?? 0}
                    total_medals={item?.total_medals ?? 0}
                    level={item?.activity_name ?? "-"}
                    teacher_name={item?.teacher_name ?? "N/A"}
                    chart_label_1="Male"
                    chart_label_2="Female"
                    chart_color_1="rgba(23, 160, 34, 1)"
                    chart_color_2="rgba(172, 216, 30, 1)"
                  />
                </div>
              );
            })}
            <AddButtonExpanded
              onClick={() =>
                setShowModal({ status: true, modalFor: TYPE.CLUB })
              }
              buttonLabel="Add Club"
            />
          </div>
        </Spin>
        <h3>Sports</h3>
        <Spin spinning={sectionLoader[TYPE.SPORT]}>
          <div className={styles.main_layout}>
            {stats?.[TYPE.SPORT]?.map((item, idx) => {
              return (
                <div key={idx}>
                  <NonAcademicInstitutionCard
                    total_students={item?.total_students ?? 0}
                    handleEdit={handleEditItem.bind(null, item, TYPE.SPORT)}
                    handleDelete={handleDeleteItem.bind(null, item, TYPE.SPORT)}
                    total_male={item?.male_count ?? 0}
                    total_female={item?.female_count ?? 0}
                    total_medals={item?.total_medals ?? 0}
                    level={item?.activity_name ?? "-"}
                    teacher_name={item?.teacher_name ?? "N/A"}
                    chart_label_1="Male"
                    chart_label_2="Female"
                    chart_color_1="rgba(23, 160, 34, 1)"
                    chart_color_2="rgba(172, 216, 30, 1)"
                  />
                </div>
              );
            })}
            <AddButtonExpanded
              onClick={() =>
                setShowModal({ status: true, modalFor: TYPE.SPORT })
              }
              buttonLabel="Add Sport"
            />
          </div>
        </Spin>
      </div>

      <CustomDrawer
        title={`${contentInfo ? "Update" : "Add"} ${showModal.modalFor}`}
        open={showModal.status}
        onClose={onClose}
        width="40vw"
        loading={Object.values(sectionLoader).includes(true)}
        className={styles.drawer}
        drawerStyles={{ body: { padding: 24, margin: 0 } }}
      >
        <AddNonAcademicContent
          handleSubmit={handleSubmit}
          contentInfo={contentInfo}
          showModal={showModal}
        />
      </CustomDrawer>
    </>
  );
};
export default NonAcademicActivity;
